import React from 'react';
import ornament from '../img/ornament.png';

const GiftSection: React.FC = () => {
  return (
    <section className="bg-white text-center p-8 overflow-hidden">
      <h2 className="text-title text-green-700">Mesa de Regalos</h2>
      {/* Separator */}
      <div className="mt-4">
        <img
          src={ornament}
          alt="Ornament"
          className="mx-auto transform scale-x-[1] ornament-size h-auto "
        />
      </div>

      <p className="mt-8 italic text-gray-500 text-lg">
        Tu presencia es el mejor regalo, pero si quieres obsequiarnos algo, aquí
        te damos algunas ideas.
      </p>

      <div className="mt-8">
        <a
          href="/mesa-de-regalos"
          className="inline-block bg-[#B94665] text-white px-8 py-3 text-sm font-semibold tracking-wide hover:bg-[#9c3b57] transition duration-300"
        >
          Ver Regalos
        </a>
      </div>
    </section>
  );
};

export default GiftSection;
